<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.procedimentoIndividualizado"
            ref="RkmDataTable"
            sort-by="unidadeNome"
            search-by="unidadeNome"
        >
            <template v-slot:cell(procedimento)="row">
                <span
                    :title="row.item.procedimentoNome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.procedimentoCodigo | formatProcedimento }}
                </span>
            </template>

            <template v-slot:cell(ocupacao)="row">
                <span
                    :title="row.item.ocupacaoNome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.ocupacaoCodigo }}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    :disabled="!!row.item.exportacaoId"
                    @click="$refs.Modal.open(row.item)"
                    color="primary"
                    small
                    title="Editar"
                    authorize="update-bpa-procedimento-individualizado"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!row.item.exportacaoId"
                    @click="handleDestroy(row.item)"
                    color="danger"
                    small
                    title="Excluir"
                    authorize="destroy-bpa-procedimento-individualizado"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>

        <Modal
            @close="$refs.RkmDataTable.refresh()"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './components/lancamento/Modal.vue'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository, stringCase } from '@/mixins'

export default {
    components: { Modal },
    created() {
        this.repositories = {
            procedimentoIndividualizado: this.getConectaSusRepository('bpa.procedimentoIndividualizado'),
        }
    },
    data: () => ({
        fields: [
            { name: 'origem', key: 'origem', label: 'Origem', searchable: true, sortable: true },
            { name: 'unidadeNome', key: 'unidadeNome', label: 'Unidade', searchable: true, sortable: true },
            { name: 'competencia', key: 'competencia', label: 'Competência', searchable: true, sortable: true },
            { name: 'usuarioNome', key: 'usuarioNome', label: 'Profissional' },
            { name: 'ocupacaoCodigo', key: 'ocupacao', label: 'CBO', searchable: true, sortable: true },
            { name: 'pacienteNome', key: 'pacienteNome', label: 'Paciente', searchable: true, sortable: true },
            { name: 'procedimentoCodigo', key: 'procedimento', label: 'Procedimento', searchable: true, sortable: true },
            { name: 'quantidade', key: 'quantidade', label: 'Quantidade' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    filters: {
        ...formats,
    },
    methods: {
        refresh() {

            this.$refs.RkmDataTable.refresh()
        },
        handleDestroy(item) {
            const request = { origem: item.origem }

            const destroy = () => this.repositories.procedimentoIndividualizado.destroy(item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.$refs.RkmDataTable.refresh()
                })

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
    },
    mixins: [ repository, stringCase ],
}
</script>